import { MaskitoOptions } from '@maskito/core';

const DEFAULT_CARD_NUMBER_LENGTH = 16;
const DIGITS_IN_GROUP = 4;

export const createCardNumberMask = (
  length = DEFAULT_CARD_NUMBER_LENGTH,
): MaskitoOptions => {
  const mask = new Array(length).fill('').reduce((result, _, index) => {
    const hasSeparatorPrefix = index > 0 && index % DIGITS_IN_GROUP === 0;

    return [...result, ...(hasSeparatorPrefix ? [' '] : []), /\d/];
  }, []);

  return {
    mask,
  };
};
